import React from "react";
import { Link } from "react-router-dom";
import "./Dashboard.css";

const Dashboard = () => {
  return (
    <div className="dashboard-component" style={{ textAlign: "center" }}>
      <div className="row">
        <div className="col s12">
          <div className="card grey darken-5">
            <div className="card-action">
              <span className="card-title">Dashboard</span>
              <p>
                This is your User Dashboard, where you'll see your KLER
                products. Create a free site to start from scratch or migrate an
                existing site.
              </p>
            </div>
            <div className="card-content white-text">
              <div className="row">
                <div className="col s3 txt-center">
                  <Link to="/menus">
                    <img src={require("../assets/app-menus.png")} alt="Menus" />
                  </Link>
                </div>
                <div className="col s4 txt-left">
                  <h4>Menus</h4>
                </div>
                <div className="col s5 txt-left">
                  <h4>Options</h4>
                </div>
              </div>
            </div>
            <div className="card-action">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
